import './App.css';
import React, { useEffect, useState } from "react";
import supabase from './supabaseClient';


// var selectedCategory = 'NA';
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}



function Friends() { 
  const [friends, setFriends] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [addFriendMessage, setAddFriendMessage] = useState('');

  // Example: Load friends list (replace with actual API call)
  useEffect(() => {
    // Simulate fetching friends
    const fetchFriends = async () => {
      // Get friends where friendof is currentuserid (remove any suffix after '-')
      const { data, error } = await supabase
      .from('Friends')
      .select('id, friend, status, Users:friend(userid, username, emailid, mobile)')
      .eq('friendof', currentuserid.split('-')[0]);

      if (!error && data) {
      // Map to display friend user info and status
      setFriends(
        data.map(f => ({
        friendid: f.id,
        id: f.userid,
        name: f.Users?.username || '',
        email: f.Users?.emailid || '',
        mobile: f.Users?.mobile || '',
        status: f.status || 'pending'
        }))
      );
      }
      else
      {
        setFriends([]);
        alert("Error fetching friends: " + error.message);
      }
    };
    fetchFriends();

    const fetchFriendsWhereFriend = async () => {
      const { data, error } = await supabase
        .from('Friends')
        .select('id, friendof, status, Users:friendof(userid, username, emailid, mobile)')
        .eq('friend', currentuserid.split('-')[0])
        .eq('status', 'confirmed');

      if (!error && data) {
        // Add these confirmed friends to the confirmedFriends list
        setFriends(prevFriends => [
          ...prevFriends,
          ...data.map(f => ({
            friendid: f.id,
            id: f.Users?.userid,
            name: f.Users?.username || '',
            email: f.Users?.emailid || '',
            mobile: f.Users?.mobile || '',
            status: f.status || 'confirmed'
          }))
        ]);
      } else {
        // Handle error if needed
        // Example: alert("Error fetching friends where friend: " + error.message);
      }
    };
    fetchFriendsWhereFriend();

    const fetchIncomingRequests = async () => {
      const { data, error } = await supabase
        .from('Friends')
        .select('id, friendof, status, Users:friendof(userid, username, emailid, mobile)')
        .eq('friend', currentuserid.split('-')[0])
        .eq('status', 'requested');

      if (!error && data) {
        setIncomingRequests(
          data.map(f => ({
            friendid: f.id,
            id: f.Users?.userid,
            name: f.Users?.username || '',
            email: f.Users?.emailid || '',
            mobile: f.Users?.mobile || '',
            status: f.status || 'requested'
          }))
        );
      } else {
        // Handle error if needed
        // Example: alert("Error fetching incoming requests: " + error.message);
      }
    };
    fetchIncomingRequests();

  }, []);

  // Handler for searching and adding friend
  const handleAddFriend = async (e) => {
    e.preventDefault();
    //alert("handleAddFriend: " + searchValue);

    const { data } = await supabase
      .from('Users')
      .select('*')
      .or(`username.ilike.%${searchValue}%,emailid.ilike.%${searchValue}%`); //mobile.ilike.%${searchValue}%
      //.single();

    if (data) {
      setSearchResult(data);
      setAddFriendMessage('');
    } else {
      setSearchResult(null);
      setAddFriendMessage('No user found.');
    }

  };

  // // Handler for confirming add friend
  // const handleConfirmAddFriend = () => {
  //   if (searchResult) {
  //     // setFriends([...friends, searchResult]);

  //     supabase
  //       .from('Friends')
  //       .insert([
  //         { friendof: currentuserid.split('-')[0], friend: searchResult.userid }
  //       ])
  //       .then(({ error }) => {
  //         if (error) {
  //           setAddFriendMessage('Error sending friend request.' + error.message);
  //         }
  //       });

  //     setAddFriendMessage(`Request sent to ${searchResult.name}!`);
  //     setSearchResult(null);
  //     setSearchValue('');
  //   }
  // };

  // Split friends by status
  const confirmedFriends = friends.filter(friend => friend.status === 'confirmed');
  const requestedFriends = friends.filter(friend => friend.status === 'requested');
  const RemovedFriends = friends.filter(friend => friend.status === 'removed');

  // State for incoming friend requests
  const [incomingRequests, setIncomingRequests] = useState([]);

  return (
    <div style={{ padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '1.1em' }}>
      <h2>My Friends Page</h2>

      { /* Add Friend Form */ }
        <div style={{ marginBottom: '30px', background: '#f9f9f9', padding: '18px 20px', borderRadius: '8px', boxShadow: '0 1px 4px #ddd' }}>
          <h3>Add New Friend</h3>
          <form onSubmit={handleAddFriend} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
          type="text"
          placeholder="Enter email or mobile"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          required
            />
            <button type="submit" style={{ padding: '8px 16px', borderRadius: '4px', background: '#1976d2', color: '#fff', border: 'none' }}>
          Find Friend
            </button>
          </form>
          {searchResult && searchResult.length > 0 && (
            <div style={{ marginTop: '10px' }}>
          <h4>Search Results:</h4>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {searchResult.map(user => (
              <li key={user.userid} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>
              {user.username} ({user.emailid || user.mobile})
            </span>
            <button
              style={{ padding: '6px 12px', borderRadius: '4px', background: '#43a047', color: '#fff', border: 'none' }}
              onClick={async () => {
                const { error } = await supabase
              .from('Friends')
              .insert([
                { friendof: currentuserid.split('-')[0], friend: user.userid }
              ]);
                if (error) {
              setAddFriendMessage('Error sending friend request: ' + error.message);
                } else {
              setAddFriendMessage(`Request sent to ${user.username}!`);
                }
              }}
            >
              Request Add Friend
            </button>
              </li>
            ))}
          </ul>
            </div>
          )}
          {addFriendMessage && (
            <div style={{ marginTop: '10px', color: 'green' }}>{addFriendMessage}</div>
          )}
        </div>

        {/* Friends Lists */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '24px' }}>
        {/* Confirmed Friends List */}
        <div style={{ background: '#f5faff', padding: '16px', borderRadius: '8px', boxShadow: '0 1px 4px #e3e3e3' }}>
          <h3>Friends</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {confirmedFriends.length === 0 && <li style={{ color: '#888' }}>No friends added.</li>}
            {confirmedFriends.map(friend => (
              <li key={friend.id} style={{ marginBottom: '8px', borderBottom: '1px solid #e0e0e0', paddingBottom: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>
                  <strong>{friend.name}</strong> <span style={{ color: '#555' }}>({friend.email || friend.mobile})</span>
                  <span style={{ marginLeft: '8px', color: '#388e3c', fontWeight: 500 }}>{friend.status}</span>
                </span>
                <button
                  style={{ marginLeft: '16px', padding: '4px 12px', borderRadius: '4px', background: '#e53935', color: '#fff', border: 'none', cursor: 'pointer' }}
                  onClick={async () => {
                    const { error } = await supabase
                      .from('Friends')
                      .update({ status: 'removed' })
                      .eq('id', friend.friendid);
                    if (!error) {
                      setFriends(prev => prev.map(f => f.id === friend.id ? { ...f, status: 'removed' } : f));
                    } else {
                      alert('Error removing friend: ' + error.message);
                    }
                  }}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div style={{ background: '#fff8f5', padding: '16px', borderRadius: '8px', boxShadow: '0 1px 4px #e3e3e3' }}>
          <h3>Sent Requests</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {requestedFriends.length === 0 && <li style={{ color: '#888' }}>No pending requests.</li>}
            {requestedFriends.map(friend => (
              <li key={friend.id} style={{ marginBottom: '8px', borderBottom: '1px solid #e0e0e0', paddingBottom: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>
                  <strong>{friend.name}</strong> <span style={{ color: '#555' }}>({friend.email || friend.mobile})</span>
                  <span style={{ marginLeft: '8px', color: '#f57c00', fontWeight: 500 }}>{friend.status}</span>
                </span>
                <button
                  style={{ marginLeft: '16px', padding: '4px 12px', borderRadius: '4px', background: '#bdbdbd', color: '#fff', border: 'none', cursor: 'pointer' }}
                  onClick={async () => {
                    const { error } = await supabase
                      .from('Friends')
                      .update({ status: 'cancelled' })
                      .eq('id', friend.friendid);
                    if (!error) {
                      setFriends(prev => prev.map(f => f.id === friend.id ? { ...f, status: 'cancelled' } : f));
                    } else {
                      alert('Error cancelling request: ' + error.message);
                    }
                  }}
                >
                  Cancel Request
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Incoming Requests List */}
        <div style={{ background: '#f5fff8', padding: '16px', borderRadius: '8px', boxShadow: '0 1px 4px #e3e3e3' }}>
          <h3>Incoming Requests</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {incomingRequests.length === 0 && <li style={{ color: '#888' }}>No incoming requests.</li>}
            {incomingRequests.map(request => (
              <li key={request.id} style={{ marginBottom: '8px', borderBottom: '1px solid #e0e0e0', paddingBottom: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>
                  <strong>{request.name}</strong> <span style={{ color: '#555' }}>({request.email || request.mobile})</span>
                  <span style={{ marginLeft: '8px', color: '#0288d1', fontWeight: 500 }}>{request.status}</span>
                </span>
                <div>
                  <button
                    style={{ marginRight: '8px', padding: '4px 12px', borderRadius: '4px', background: '#43a047', color: '#fff', border: 'none', cursor: 'pointer' }}
                    onClick={async () => {
                      const { error } = await supabase
                        .from('Friends')
                        .update({ status: 'confirmed' })
                        .eq('id', request.friendid);
                      if (!error) {
                        setIncomingRequests(prev => prev.map(r => r.id === request.id ? { ...r, status: 'confirmed' } : r));
                      } else {
                        alert('Error confirming request: ' + error.message);
                      }
                    }}
                  >
                    Confirm
                  </button>
                  <button
                    style={{ padding: '4px 12px', borderRadius: '4px', background: '#e53935', color: '#fff', border: 'none', cursor: 'pointer' }}
                    onClick={async () => {
                      const { error } = await supabase
                        .from('Friends')
                        .update({ status: 'removed' })
                        .eq('id', request.friendid);
                      if (!error) {
                        setIncomingRequests(prev => prev.map(r => r.id === request.id ? { ...r, status: 'removed' } : r));
                      } else {
                        alert('Error removing request: ' + error.message);
                      }
                    }}
                  >
                    Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Removed Friends List */}
        <div style={{ background: '#fff5fa', padding: '16px', borderRadius: '8px', boxShadow: '0 1px 4px #e3e3e3' }}>
          <h3>Removed Friends</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {RemovedFriends.length === 0 && <li style={{ color: '#888' }}>No Removed friends.</li>}
            {RemovedFriends.map(friend => (
              <li key={friend.id} style={{ marginBottom: '8px', borderBottom: '1px solid #e0e0e0', paddingBottom: '6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span>
                  <strong>{friend.name}</strong> <span style={{ color: '#555' }}>({friend.email || friend.mobile})</span>
                  <span style={{ marginLeft: '8px', color: '#c2185b', fontWeight: 500 }}>{friend.status}</span>
                </span>
                <button
                  style={{ marginLeft: '16px', padding: '4px 12px', borderRadius: '4px', background: '#43a047', color: '#fff', border: 'none', cursor: 'pointer' }}
                  onClick={async () => {
                    const { error } = await supabase
                      .from('Friends')
                      .update({ status: 'confirmed' })
                      .eq('id', friend.friendid);
                    if (!error) {
                      setFriends(prev => prev.map(f => f.id === friend.id ? { ...f, status: 'confirmed' } : f));
                    } else {
                      alert('Error adding back friend: ' + error.message);
                    }
                  }}
                >
                  Add Back
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Friends;